import gql from 'graphql-tag';

export const ADD_APPLICATION_ITEM = (itemName?: string): any => {
  const addApplicationItemGql = gql`
  mutation ($id: String!, $input: AddApplicationItemInput!) {
    addApplicationItem(
      id: $id
      input: $input
    ) {
      ${itemName}{
        _id
      }
    }
  }
  `;
  return addApplicationItemGql;
};
